import React, { type SyntheticEvent, useState } from 'react';

import { type TypeDataset } from '../common/dataTypes';
import { useGetIFS } from '../hooks/tanstack/useIFSHook';
import { useGetRouteParams } from '../hooks/tanstack/useUtilsHook';

import IFSViewFilesDataTable from './dataset/IFSViewFilesDataTable';
import ReviewIFSTable from './dataset/ReviewIFSTable';
import { CustomTabPanel, Tab, Tabs } from './mui-custom';

const TABS = ['Data files', 'View Data'];

type ReviewIFSFilesTabsProps = {
  dataset: TypeDataset;
};

const ReviewIFSFilesTabs = ({ dataset }: ReviewIFSFilesTabsProps) => {
  const [index, setIndex] = useState(0);

  const { orgId, projectId } = useGetRouteParams();

  const handleChange = (event: SyntheticEvent, newValue: number) => {
    setIndex(newValue);
  };

  const {
    data: ifs,
    isLoading: isLoadingIFS,
    isRefetching: isRefetchingIFS,
  } = useGetIFS(
    {
      projectId,
      datasetId: dataset.id,
      orgId,
    },
    {
      enabled: !!dataset && !!orgId && !!projectId,
    }
  );

  return (
    <div className="flex flex-col gap-4">
      <Tabs value={index} onChange={handleChange}>
        {TABS.map((report) => (
          <Tab id={report} key={report} label={report} />
        ))}
      </Tabs>
      <CustomTabPanel value={index.toString()} index="0">
        {ifs && projectId && (
          <ReviewIFSTable
            isLoading={isLoadingIFS || isRefetchingIFS}
            projectId={projectId}
            dataset={dataset}
            ifs={{
              ...ifs,
              files: ifs.files,
            }}
          />
        )}
      </CustomTabPanel>
      <CustomTabPanel value={index.toString()} index="1">
        <IFSViewFilesDataTable />
      </CustomTabPanel>
    </div>
  );
};

export default ReviewIFSFilesTabs;
